import manageRoutes from './manage';

/**
 * 路由配置
 * @meta {Object} meta
 * @meta {Boolean} meta.pageloading 是否显示页面加载中
 * @meta {Boolean} meta.sidebar 是否显示左侧导航（false：不显示，1：客户可见菜单，2：管理员可见菜单）
 * @meta {Boolean} meta.disabled 是否禁用
 * @meta {String} meta.title 标题
 * @meta {String} meta.icon 图标
 * @meta {Boolean} meta.breadcrumb 是否显示面包屑
 * @meta {Boolean} meta.hasChildrenMenu 是否有子菜单
 * @meta {Array} meta.authKey 权限
 * @meta {Boolean} meta.hide 是否在菜单中隐藏
 * @meta {Boolean} meta.autoCollect false时，表示历史记录仅在页面手动收集（因为需要收集页面的标题）
 */
const routes = [
  // 根目录跳转
  {
    path: '/',
    name: 'Root',
  },

  // 登录
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "Login" */ '../views/login'),
  },

  // 忘记密码
  {
    path: '/find-password',
    name: 'FindPassword',
    component: () => import(/* webpackChunkName: "FindPassword" */ '../views/find-password'),
    meta: {
      pageloading: false,
    },
  },
  {
    path: '/find-password/reset',
    name: 'FindPasswordReset',
    component: () =>
      import(/* webpackChunkName: "FindPasswordReset" */ '../views/find-password/reset'),
    meta: {
      pageloading: false,
    },
  },

  // 附件分享
  {
    path: '/share/file',
    name: 'ShareFile',
    component: () =>
      import(/* webpackChunkName: "FindPasswordReset" */ '../views/attach/share.vue'),
    meta: {
      pageloading: false,
    },
  },

  // 后台管理路由
  // 后台管理路由path为manage开头，不可轻易修改，因为src/components/Layout/index.vue有判断
  {
    path: '/manage',
    name: 'Manage',
    redirect: '/manage/home',
    component: () => import(/* webpackChunkName: "Manage" */ '../views/main'),
    meta: {
      sidebar: true,
      disabled: false,
      title: 'com_sider_menu_home',
    },
    children: [...manageRoutes],
  },

  {
    path: '/error',
    name: 'Error',
    component: () => import(/* webpackChunkName: "Error" */ '../views/error/404.vue'),
    meta: {
      pageloading: false,
    },
  },

  {
    path: '*',
    name: 'notFound',
    component: () => import(/* webpackChunkName: "Error" */ '../views/error/404.vue'),
    meta: {
      pageloading: false,
    },
  },
];

export default routes;
